<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasButton('add')" type="primary" :disabled="loading || !loadedMonth" @click="openAdd">新增</el-button>
        <el-button v-if="hasButton('export')" type="primary" :disabled="loading || !loadedMonth" @click="exportPdf">导出个人绩效明细PDF</el-button>
      </template>
      <el-form inline>
        <el-form-item label="月份"><el-date-picker v-model="month" type="month" value-format="yyyy-MM" :clearable="false" :disabled="loading" @change="load" /></el-form-item>
        <el-form-item><el-button type="primary" :loading="loading" @click="load">查询</el-button></el-form-item>
      </el-form>
    </custom-actions>
    <el-card class="mt10" shadow="never">
      <div class="budget">
        <span>当月绩效总额：<strong>{{ money(summary.totalAmount) }}</strong></span>
        <span>生产绩效：<strong>{{ money(summary.productionAmount) }}</strong></span>
        <span>已填报：<strong>{{ money(summary.filledAmount) }}</strong></span>
        <span>剩余额度：<strong>{{ money(summary.remainingAmount) }}</strong></span>
        <span>额外绩效：<strong>{{ money(summary.extraAmount) }}</strong></span>
        <el-button v-if="hasButton('addOther')" type="primary" size="small" :disabled="loading || !loadedMonth || saving || extraSaving || deleting" @click="openExtra">添加额外绩效</el-button>
      </div>
<!--      <div class="budget-hint">当月绩效总额（绩效池）＝生产绩效＋额外绩效</div>-->
      <el-table :data="rows" v-loading="loading" border class="mt15">
        <el-table-column label="月份" prop="month" width="110" />
        <el-table-column label="部门" prop="deptName" />
        <el-table-column label="人员" prop="userName" />
        <el-table-column label="奖惩" prop="assessment" min-width="160" show-overflow-tooltip />
        <el-table-column label="绩效金额"><template #default="{ row }">{{ money(row.performancePrice) }}</template></el-table-column>
        <el-table-column label="填报时间" prop="ctime" width="180" />
        <el-table-column label="操作" width="150"><template #default="{ row }">
          <el-button v-if="hasButton('edit')" type="text" :disabled="loading" @click="openEdit(row)">编辑</el-button>
          <el-button v-if="hasButton('delete')" type="text" :disabled="loading || deleting" @click="remove(row)">删除</el-button>
        </template></el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="添加额外绩效" :visible.sync="extraVisible" width="480px" :close-on-click-modal="false" :close-on-press-escape="!extraSaving" :show-close="!extraSaving">
      <el-form label-width="100px" @submit.native.prevent>
        <el-form-item label="月份">{{ extraForm.month }}</el-form-item>
        <el-form-item label="类型">{{ extraForm.productType === '1' ? '精炼' : '包装' }}</el-form-item>
        <el-form-item label="绩效金额" required>
          <el-input v-model="extraForm.performancePrice" :disabled="extraSaving" maxlength="19" placeholder="请输入金额，最多两位小数"><template slot="append">元</template></el-input>
        </el-form-item>
      </el-form>
      <el-alert title="保存将覆盖本月本类型的额外绩效金额，填写 0 可清零。" type="info" :closable="false" />
      <div slot="footer"><el-button :disabled="extraSaving" @click="extraVisible = false">取消</el-button><el-button type="primary" :loading="extraSaving" @click="saveExtra">保存</el-button></div>
    </el-dialog>
    <el-dialog :title="editing ? '编辑个人绩效' : '新增个人绩效（批量填写）'" :visible.sync="visible" width="1100px" :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
      <p>填报月份：{{ formMonth }} &nbsp; 可用额度：{{ money(available) }} &nbsp; 本次合计：{{ money(formTotal) }} &nbsp; 剩余额度：<strong :class="{ 'over-budget': overBudget }">{{ money(formRemaining) }}</strong></p>
      <el-table :data="formRows" border>
        <el-table-column label="序号" type="index" width="55" />
        <el-table-column label="人员" min-width="240"><template #default="{ row }">
          <el-select v-model="row.userId" filterable :disabled="saving" placeholder="请选择人员" style="width:100%">
            <el-option v-for="user in users" :key="user.userId" :value="user.userId" :label="(user.deptName || '未分部门') + ' / ' + user.userName" />
          </el-select>
        </template></el-table-column>
        <el-table-column label="奖惩" min-width="200"><template #default="{ row }">
          <el-input v-model="row.assessment" type="textarea" :rows="2" :maxlength="200" :disabled="saving" placeholder="选填奖惩说明" />
        </template></el-table-column>
        <el-table-column label="绩效金额" width="220"><template #default="{ row }">
          <el-input-number v-model="row.performancePrice" :min="0" :max="999999999999.99" :precision="2" :disabled="saving" />
        </template></el-table-column>
        <el-table-column v-if="!editing" label="操作" width="110"><template #default="{ $index }">
          <el-button icon="el-icon-plus" circle size="mini" title="加一行" :disabled="saving || formRows.length >= 200" @click="addRow" />
          <el-button icon="el-icon-minus" circle size="mini" title="删除此行" :disabled="saving || formRows.length === 1" @click="formRows.splice($index, 1)" />
        </template></el-table-column>
      </el-table>
      <el-alert v-if="overBudget" class="mt15" title="当月累计填报金额不能大于当月绩效总额" type="error" :closable="false" />
      <div slot="footer"><el-button :disabled="saving" @click="visible = false">取消</el-button><el-button type="primary" :loading="saving" :disabled="overBudget" @click="save">保存</el-button></div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from 'bignumber.js'
import { exportFiles } from '@/utils/globalMethods'
export default {
  name: 'ProductionPersonalPerformance',
  data() {
    return { month: this.$dayjs().format('YYYY-MM'), loadedMonth: '', rows: [], summary: {}, users: [], loading: false, saving: false, deleting: false, visible: false, editing: false, formMonth: '', formProductType: '', formRows: [], originalAmount: 0, loadVersion: 0, extraVisible: false, extraSaving: false, extraForm: { month: '', productType: '', performancePrice: '' } }
  },
  computed: {
    productType() {
      return this.$route.query.productType || '2'
    },
    menuCode() {
      return this.productType === '1' ? 'JLSCGRJX' : 'SCGRJX'
    },
    buttonList() {
      return this.$store.getters.getMenuByCode(this.menuCode)
    },
    // 金额计算使用十进制，编辑额度先返还原记录金额，后端仍以事务内最新余额为准。
    formTotal() { return this.formRows.reduce((total, row) => total.plus(row.performancePrice || 0), new BigNumber(0)) },
    available() { return new BigNumber(this.summary.remainingAmount || 0).plus(this.originalAmount) },
    // 草稿金额或行数变化时实时扣减；编辑先返还原金额，超额保留负数提示差额。
    formRemaining() { return this.available.minus(this.formTotal) },
    overBudget() { return this.formTotal.gt(this.available) }
  },
  watch: {
    productType(val, oldVal) {
      if (val && val !== oldVal) {
        this.visible = false
        this.extraVisible = false
        this.month = this.$dayjs().format('YYYY-MM')
        this.loading = false
        this.load()
      }
    }
  },
  created() { this.load() },
  methods: {
    hasButton(code) {
      return this.buttonList.some(item => item === code)
    },
    money(value) { return new BigNumber(value || 0).toFixed(2) },
    async load() {
      if (!this.month || this.loading) return
      this.loading = true
      this.loadedMonth = ''
      const month = this.month
      const productType = this.productType
      const version = ++this.loadVersion
      try {
        const result = await this.$axios.get(this.$apis.productionPerformance.monthlyList, { month, productType })
        if (version !== this.loadVersion) return
        this.rows = result.list || []
        this.summary = result
        this.loadedMonth = month
      } catch (error) {
        if (version !== this.loadVersion) return
        this.rows = []; this.summary = {}; throw error
      } finally { if (version === this.loadVersion) this.loading = false }
    },
    openExtra() {
      if (!this.loadedMonth || this.loading) return
      this.extraForm = { month: this.loadedMonth, productType: this.productType, performancePrice: this.money(this.summary.extraAmount) }
      this.extraVisible = true
    },
    async saveExtra() {
      if (this.extraSaving) return
      const amount = String(this.extraForm.performancePrice || '').trim()
      if (!/^\d{1,16}(\.\d{1,2})?$/.test(amount)) return this.$message.warning('请输入非负金额，最多16位整数和两位小数')
      this.extraSaving = true
      try {
        await this.$axios.post(this.$apis.productionPerformance.monthlySaveExtra, { ...this.extraForm, performancePrice: this.money(amount) })
        this.extraVisible = false
        this.$message.success('额外绩效保存成功')
        await this.load()
      } finally { this.extraSaving = false }
    },
    async loadUsers() { this.users = await this.$axios.get(this.$apis.productionPerformance.selectOrganizationUsers) || [] },
    async openAdd() {
      const month = this.loadedMonth
      const productType = this.productType
      await this.loadUsers()
      if (!month || month !== this.loadedMonth || productType !== this.productType) return
      this.editing = false
      this.formMonth = month
      this.formProductType = productType
      this.originalAmount = 0
      this.formRows = []
      this.addRow()
      this.visible = true
    },
    async openEdit(row) {
      const productType = this.productType
      await this.loadUsers()
      if (row.month !== this.loadedMonth || productType !== this.productType) return
      this.editing = true
      this.formMonth = row.month
      this.formProductType = productType
      this.originalAmount = row.performancePrice
      // 编辑仅回填人员、绩效和考核，历史出勤数据不再进入表单及提交参数。
      this.formRows = [{ id: row.id, userId: row.userId, performancePrice: Number(row.performancePrice), assessment: row.assessment || '' }]
      this.visible = true
    },
    // 加号只添加本次新增草稿，保存时整批提交，取消不会生成任何记录。
    addRow() { this.formRows.push({ userId: '', performancePrice: 0, assessment: '' }) },
    // 保存个人绩效，考核选填且最多200字，空值统一提交为空字符串。
    async save() {
      if (this.saving) return
      if (this.formRows.some(row => !row.userId || row.performancePrice == null || !Number.isFinite(row.performancePrice))) return this.$message.warning('请完整填写人员和绩效金额')
      if (this.formRows.some(row => (row.assessment || '').trim().length > 200)) return this.$message.warning('奖惩最多200字')
      if (this.overBudget) return this.$message.warning('当月累计填报金额不能大于当月绩效总额')
      this.saving = true
      try {
        const api = this.editing ? this.$apis.productionPerformance.monthlyUpdate : this.$apis.productionPerformance.monthlyAdd
        await this.$axios.post(api, { month: this.formMonth, productType: this.formProductType, personList: this.formRows.map(row => ({ ...row, performancePrice: this.money(row.performancePrice), assessment: (row.assessment || '').trim() })) })
        this.visible = false
        this.$message.success('保存成功')
        await this.load()
      } finally { this.saving = false }
    },
    async remove(row) {
      const productType = row.productType
      try { await this.$confirm('确认删除该人员本条月度绩效填报？', '提示', { type: 'warning' }) } catch (_) { return }
      this.deleting = true
      try {
        await this.$axios.post(this.$apis.productionPerformance.monthlyDelete, { id: row.id, month: row.month, productType })
        await this.load()
      } finally { this.deleting = false }
    },
    // 个人报表只从独立月份入口导出，日期按选中月份展开。
    exportPdf() {
      const date = this.$dayjs(this.loadedMonth + '-01')
      exportFiles(this.$apis.productionPerformance.exportPersonPerformancePdf, { startDate: date.format('YYYY-MM-DD'), endDate: date.endOf('month').format('YYYY-MM-DD'), productType: this.productType }, '个人绩效明细表.pdf')
    }
  }
}
</script>
<style scoped>
.budget { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; font-size: 16px; padding-bottom: 12px; }
.budget strong { color: #409eff; }
.budget-hint { color: #909399; font-size: 13px; }
.over-budget { color: #f56c6c; }
</style>
